import { storyblokEditable } from "@storyblok/react/rsc";

export const editableField = (blok) => {
  return {
    ...storyblokEditable(blok)
  }
}